// removed by extract-text-webpack-plugin
module.exports = {"active-or-coming-soon":"active-or-coming-soon__tAQru","closed":"closed__yDUwg","divider":"divider__3q5ER","closed-list":"closed-list__3s6V-"};


//////////////////
// WEBPACK FOOTER
// ./routes/home/Home.scss
// module id = hpTs
// module chunks = 1